//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { InsurStore, InsurMutations} from '../../store'
import Rate from './rate'


    export default {
        data() {
            return {
                modeShow:false
            }
        },
        computed: {
            isShowFee() {
                return InsurStore.insuranceform.isShowFee
            }
        },
        components: {
            Rate,
        },
        props: {
            productCode: {
                type: [Number,String],
                default: ""
            },
        },
        methods: {
            details() {
                this.modeShow = true
                this.STATISTICS_CONFIG.insur_insurinfoinput_rate_click()
            },
        },
    }
